export default __webpack_public_path__ + "04598eb.png";